import {createTheme} from '@mui/material/styles';
import {FONT_FAMILY} from '../../common/sharedFunctions';

const adminTheme = createTheme({
  palette: {
    primary: {
      main: '#191919',
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#B7EE00',
      contrastText: '#191919',
    },
    background: {
      default: '#F5F7F2',
      paper: '#FFFFFF',
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: FONT_FAMILY,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          fontWeight: 600,
          textTransform: 'none',
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: 'none',
        },
      },
    },
  },
});

export default adminTheme;
